import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {nbsp} from '~/constants/StringConstants';
import Notification from '~/components/Notification';
import {metrics} from '~/vendor/metrics';
import {Button, Stack} from '@customink/pigment-react';

const propTypes = {
  changeColor: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    alternative: PropTypes.object,
    color: PropTypes.object
  })
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class RetiredProductColorNotification extends Component {
  static displayName = 'RetiredProductColorNotification';
  static propTypes = propTypes;

  handleRecommendedColorSwap = () => {
    const prevColor = this.props.notification.color;
    metrics.pageViewTag('ndx/product/color/discontinued/swap');
    this.props.dismiss();
    this.props.changeColor(prevColor.id, prevColor.alternative_id);
  };

  render() {
    const {
      dismiss,
      notification: {color, alternative}
    } = this.props;
    const hasAltColor = !!alternative; // the recommendation is a product with a different color
    const hasAltId = !!color.alternative_id; // has a recommended product or product color

    // Looking at the different scenarios, if the product is inactive, the
    // "InactiveProductNotification" modal should appear, so we don't need to worry about it
    //
    // We only enter this modal if we have a color of the product in our design that is now unavailable
    if (hasAltId) {
      let notificationDesc, ctaPrimary, ctaText;
      if (hasAltColor) {
        notificationDesc = (
          <p>
            Would you like us to recommend a great alternative
            <br /> color for you, or would you like to choose your own?
          </p>
        );
        ctaPrimary = 'Try Recommended Color';
        ctaText = 'Choose Your Own';
      } else {
        notificationDesc = (
          <p>
            Would you like us to recommend a great alternative
            <br /> product for you, or would you like to choose your own?
          </p>
        );
        ctaPrimary = 'Try Recommended Product';
        ctaText = 'Select a Different Color';
      }

      return (
        <Notification
          title={`One of your product colors is currently${nbsp}unavailable!`}>
          {notificationDesc}
          <Stack className="notification-stack">
            <Button
              size="large"
              className="notification-cta"
              onClick={this.handleRecommendedColorSwap}>
              {ctaPrimary}
            </Button>
            <Button
              size="large"
              variant="link"
              className="notification-cta"
              href="#/productColor"
              onClick={dismiss}>
              {ctaText}
            </Button>
          </Stack>
        </Notification>
      );
    }

    return (
      <Notification
        title={`One of your product colors is currently${nbsp}unavailable!`}>
        <p>
          We’re sorry, the product in this color is currently unavailable.
          Please select a different color.
        </p>
        <div className="ndx-Notification-actions">
          <Button
            size="large"
            className="notification-cta"
            href="#/productColor"
            onClick={dismiss}>
            Select a Different Color
          </Button>
        </div>
      </Notification>
    );
  }
}

import {bindActionCreators} from 'redux';
import {changeColor} from '~/actions/ProductActions';

function actions(dispatch) {
  return bindActionCreators(
    {
      changeColor
    },
    dispatch
  );
}

import {connect} from 'react-redux';

export default connect(null, actions)(RetiredProductColorNotification);
